import React, { useContext, useEffect, useState } from "react";
import { Link as ReactLink } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import { Grid, Typography, Breadcrumbs, Link, Button } from "@material-ui/core";
import ReplyRoundedIcon from "@material-ui/icons/ReplyRounded";

// Contexts
import OrderContext from "../../../../context/orders/v1/OrdersContext";
import MernCountryContext from "../../../../context/mern_Countries/CountryContext";
import MernProductContext from "../../../../context/mern_Products/ProductContext";

// Components
import Spinner from "../../../layout/Spinner";
import OrderInfo from "./OrderEditInfoOrder";
import CustomerInfo from "./OrderEditInfoCustomer";
import Unfulfilled from "./OrderEditItemUnfulfilled";
import Fulfilled from "./OrderEditItemFulfilled";
import Removed from "./OrderEditItemRemoved";
import Paid from "./OrderEditPaid";
import Refunded from "./OrderEditRefunded";
import MainModal from "./MainModal";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    fontSize: "0.9rem",
  },
  breadcrumbsLink: {
    color: theme.palette.text.secondary,
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary,
  },
  rowBottom: {
    marginBottom: "1rem",
  },
  subtitle: {
    color: theme.palette.text.secondary,
  },
  button: {
    textTransform: "none",
  },
}));

const OrderEdit = (props) => {
  const classes = useStyles();
  const { order, setOrder, setModal } = useContext(OrderContext);
  const { getMernCountries } = useContext(MernCountryContext);
  const { mern_products, getMernProducts } = useContext(MernProductContext);

  const [created_at, setCreatedAt] = useState();
  const [currentFulfilled, setCurrentFulfilled] = useState();
  const [fulfilledItems, setFulfilledItems] = useState([]);
  const [unfulfilledItems, setUnfulfilledItems] = useState([]);
  const [removedItems, setRemovedItems] = useState([]);
  const [products, setProducts] = useState({});

  const getImage = (variant_id, product) => {
    let imageSrc = "";

    // Get Image In Variant Level
    if (product.images) {
      for (let x in product.images) {
        for (let y in product.images[x].variant_ids) {
          if (variant_id === product.images[x].variant_ids[y]) {
            imageSrc = product.images[x].src;
            break;
          }
        }
        if (imageSrc) {
          break;
        }
      }
    }

    // Get Image In Product Level
    if (imageSrc === "") {
      imageSrc = product.image.src;
    }

    return imageSrc;
  };

  useEffect(() => {
    if (props.location.state && props.location.state.order) {
      const copied = JSON.parse(JSON.stringify(props.location.state.order));
      setOrder(copied);
    }

    // Get Countries
    getMernCountries();
  }, []);

  useEffect(() => {
    if (order) {
      // Format Created At
      const date = new Date(order.created_at);

      const newDate = new Intl.DateTimeFormat("en", {
        year: "numeric",
        month: "long",
        day: "numeric",
        hour12: true,
        hour: "numeric",
        minute: "2-digit",
        // timeStyle: "short",
        // dateStyle: "long",
      }).format(date);

      setCreatedAt(newDate);

      let fulfilled_summary = {};
      let fulfilled_items = [];
      let unfulfilled_items = [];
      let removed_items = [];

      // Get Fulfilled Items
      order.fulfillments.map((each) => {
        if (each.status === "success") {
          fulfilled_items = fulfilled_items.concat(each);
        }
      });

      // // Get Fulfilled Summary To Cross Check Unfulfilled Items
      // fulfilled_items.map((each) => {
      //   each.line_items.map((each_items) => {
      //     if (each_items.id in fulfilled_summary) {
      //       const qty = fulfilled_summary[each_items.id] + each_items.quantity;
      //       fulfilled_summary[each_items.id] = qty;
      //     } else {
      //       fulfilled_summary[each_items.id] = each_items.quantity;
      //     }
      //   });
      // });

      // Get Unfulfilled Items
      order.line_items.map((item) => {
        // // Cross Check Unfulfilled Items' Quantity With Fulfilled Summary
        // if (item.id in fulfilled_summary) {
        //   if (fulfilled_summary[item.id] < item.quantity) {
        //     item.quantity = item.quantity - fulfilled_summary[item.id];
        //     unfulfilled_items.push(item);
        //   }
        // } else {
        //   unfulfilled_items.push(item);
        // }

        if (
          // item.fulfillment_status !== "fulfilled" ||
          item.fulfillable_quantity > 0
        ) {
          unfulfilled_items.push(item);
        }
      });

      // Get Removed Items
      let added_id = [];

      order.refunds.map((refund) => {
        refund.refund_line_items.map((each) => {
          if (
            each.line_item.fulfillment_status !== "fulfilled" &&
            each.line_item.fulfillment_status !== "partial"
          ) {
            if (!added_id.includes(each.line_item.product_id)) {
              added_id.push(each.line_item.product_id);
              removed_items = removed_items.concat(each);
            }
          }
        });
      });

      setFulfilledItems(fulfilled_items);
      setUnfulfilledItems(unfulfilled_items);
      setRemovedItems(removed_items);

      // Get Product's ID
      let products = [];

      unfulfilled_items.map((each) => {
        if (each.product_id && !products.includes(each.product_id)) {
          products.push(each.product_id);
        }
      });

      fulfilled_items.map((each) => {
        each.line_items.map((item) => {
          if (item.product_id && !products.includes(item.product_id)) {
            products.push(item.product_id);
          }
        });
      });

      removed_items.map((each) => {
        if (
          each.line_item.product_id &&
          !products.includes(each.line_item.product_id)
        ) {
          products.push(each.line_item.product_id);
        }
      });

      // Get Product From DB
      products.map((id) => {
        if (id) {
          getMernProducts(id);
        }
      });

      // Update Location State With New Order
      if (props.location.state && props.location.state.order) {
        props.history.replace({
          pathname: "/order/edit",
          state: {
            order: order,
          },
        });
      }
    }
  }, [order]);

  useEffect(() => {
    if (mern_products && mern_products.length !== 0) {
      // Get Product From DB In Order To Retrieve Image
      setProducts({ ...products, [mern_products[0].id]: mern_products[0] });
    }
  }, [mern_products]);

  return order ? (
    <div className={classes.root}>
      <Grid container spacing={1}>
        <Grid container spacing={0} justifyContent="flex-start">
          <Grid item xs={12}>
            <Typography variant="h4"> Order </Typography>{" "}
          </Grid>{" "}
          <Grid item xs={12}>
            <Breadcrumbs aria-label="breadcrumb">
              <ReactLink
                to={{
                  pathname: "/order",
                }}
                className={classes.breadcrumbsLink}
              >
                Order{" "}
              </ReactLink>{" "}
              <Link color="inherit"> {order.name} </Link>{" "}
            </Breadcrumbs>{" "}
          </Grid>{" "}
          <Grid item xs={12}>
            <Typography variant="body2" className={classes.subtitle}>
              {" "}
              {order.store_name} & ensp; & ensp; {created_at}{" "}
            </Typography>{" "}
          </Grid>{" "}
          <Grid item xs={12}>
            <Button
              color="primary"
              className={classes.button}
              startIcon={<ReplyRoundedIcon />}
              onClick={() => setModal(true, "refund")}
              disabled={order.financial_status !== "refunded" ? false : true}
            >
              Refund{" "}
            </Button>{" "}
          </Grid>{" "}
        </Grid>
        <Grid
          container
          spacing={3}
          direction="row"
          alignItems="flex-start"
          justifyContent="space-around"
          style={{
            marginTop: "0.3rem",
          }}
        >
          <Grid
            item
            xs={9}
            container
            direction="column"
            alignItems="flex-start"
            justifyContent="flex-start"
            className={classes.rowBottom}
          >
            {" "}
            {/* Line Items */}{" "}
            {unfulfilledItems.length > 0 && (
              <Unfulfilled
                getImage={getImage}
                unfulfilledItems={unfulfilledItems}
                products={products}
              />
            )}{" "}
            {removedItems.length > 0 && (
              <Removed
                getImage={getImage}
                removedItems={removedItems}
                products={products}
              />
            )}{" "}
            {fulfilledItems.length > 0 && (
              <Fulfilled
                getImage={getImage}
                setCurrentFulfilled={setCurrentFulfilled}
                fulfilledItems={fulfilledItems}
                products={products}
              />
            )}
            {/* Payment Summary */}{" "}
            {order.financial_status === "paid" && <Paid />}{" "}
            {order.financial_status === "partially_refunded" && <Refunded />}{" "}
            {order.financial_status === "refunded" && <Refunded />}{" "}
          </Grid>
          <Grid
            item
            xs={3}
            container
            direction="column"
            alignItems="flex-start"
            justifyContent="flex-start"
            className={classes.rowBottom}
          >
            <OrderInfo />
            <CustomerInfo />
          </Grid>
          {/* Modal */}{" "}
          <MainModal
            getImage={getImage}
            currentFulfilled={currentFulfilled}
            fulfilledItems={fulfilledItems}
            unfulfilledItems={unfulfilledItems}
            products={products}
          />{" "}
        </Grid>{" "}
      </Grid>{" "}
    </div>
  ) : (
    <div
      className="d-flex mx-auto my-auto"
      style={{
        height: "80vh",
      }}
    >
      <Spinner />
    </div>
  );
};

export default OrderEdit;
